import {
  URL_DASHBOARD,
  URL_SEARCH,
  URL_DATA_SOURCES_STRUCTURED,
  URL_DATASOURCE_FORM,
  URL_ENTITIES,
  URL_SETTINGS,
  URL_DOCUMENTS_CLASSIFIED,
  URL_DOCUMENTS_UNCLASSIFIED_WITH_ENTITIES,
  URL_DOCUMENTS_ALL,
  URL_DOCUMENT,
  URL_ATTRIBUTES,
  URL_CONVERSATIONS,
  URL_EMAILS,
  URL_VIOLATIONS,
  URL_USERS,
  URL_DOCUMENTS_UNCLASSIFIED_WITHOUT_ENTITIES,
  URL_POLICIES,
  URL_DATASOURCE_FORM_UNSTRUCTURED,
  URL_DATABASES,
  URL_TABLES,
  URL_REGISTER_ELASTIC_SEARCH,
  URL_FILTER,
  URL_INSIGHTS,
  URL_PRIVACY_PARTNERS,
  URL_DAYZERO,
  URL_ATTRIBUTES_SET,
  URL_DATA_SOURCES,
  URL_TICKETS,
  URL_RULE_SET,
  URL_DATASOURCE_FORM_STRUCTURED,
  URL_DSR,
  URL_ROPA,
  URL_PRINT_CLOSING,
  URL_PRINT_COVER,
  URL_PRINT_ROPA_CONTENT,
  URL_PRINT_PIA_CONTENT,
  URL_PRINT,
  URL_ENTITIES_DELETED,
  URL_PRINT_DSR_CONTENT,
  URL_MANAGE_ACCOUNT,
  MESSAGES,
  DEFAULT_LANGUAGE,
  URL_COOKIES_CONSENT,
  URL_ONDEMAND,
  URL_DELTA_PRINT,
  URL_PIA,
  URL_FILTERS,
  URL_ACCESS_CONTROL,
  URL_CLOUD_PLATFORMS,
  URL_CLOUD_PLATFORMS_ONBOARDING,
  URL_CLOUD_RESOURCES,
  URL_CONSENT_MANAGEMENT,
  URL_PRINT_CC_VERSION_CONTENT,
  ACTION_USER_INFO,
  URL_PRIVACY_OPS,
  URL_OVERVIEW,
  URL_VIEWS,
  URL_VIVA_ENGAGE_CALLBACK,
  URL_UNAUTHORIZED,
  NON_PROTECTED_ROUTES,
  URL_NOTIFICATIONS,
  URL_WORKFLOWS,
  URL_CREATE_WORKFLOW
} from './constants'
import ThemeContextProvider from './features/dashboards/mainDashboardv2/components/ThemeContext'
import GlobalSearch from './features/globalSearch'
import ProtectedRoute from './components/ProtectedRoute'
import AccessDenied from './components/AccessDenied'
import ElasticSearchForm from './features/dataSources/components/UnstructuredForm/ElasticSeach'
import Notification from './features/notification/notification'
import Modals from './features/modals/modals'
import history from './services/historyService'
import Loading from './features/loading/loading'
import LoaderView from './components/Loader/loader'
import PrintCover from './print/printCover'
import PrintClosingPage from './print/printClosing'
import { RootState } from './rootReducer'
import DeltaPrintPage from './print/delta-report/main'
import PrintPage from './print/print'
import LightBeamDesignSystem from './components/LightbeamDesignSystem'
import SelectFileToCreateFilter from './features/policies/components/SelectFileToCreateFilter'
import { getShowLoader } from './reducers/requestReducer'
import { ACTION_FETCH_FEATURE_FLAGS } from './configs/featureFlagSlice'
import ReportingErrorBoundary from './components/ErrorBoundary/reports'
import { withErrorBoundary } from './components/ErrorBoundary/withErrorBoundary'
import PermissionProvider from './HOCs/PermissionProvider'
import AuthProvider from './HOCs/AuthProvider'
import { ACTIONS } from './components/PermissionMapper/constants'
import { MsVivaEngageCallback } from './features/dataSources/components/UnstructuredForm/MsVivaEngage/msVivaEngageCallback'
import NonProtectedRoute from './components/NonProtectedRoute'
import FirstLanding from '../src/features/firstLanding/firstLanding'
import loadable from '@loadable/component'
import React from 'react'
import { Redirect, Router, Switch } from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import { useSelector } from 'react-redux'
import { Loader, SnackbarProvider } from '@lightbeamai/design-system'

const LoadableLoader = () => {
  return (
    <div className="loadable-loader">
      <Loader loading size={48} />
    </div>
  )
}

const MainDashBoard = loadable(
  () =>
    import(
      /* webpackChunkName: "main-dashboard" */
      /* webpackMode: "loadable" */ './features/dashboards/mainDashboard/mainDashboard'
    ),
  {
    fallback: <LoadableLoader />
  }
)

const MainDashBoardV2 = loadable(
  () =>
    import(
      /* webpackChunkName: "main-dashboard-v2" */
      /* webpackMode: "loadable" */ './features/dashboards/mainDashboardv2'
    ),
  {
    fallback: <LoadableLoader />
  }
)

const DataSourcesPage = loadable(
  () =>
    import(
      /* webpackChunkName: "dataSource" */
      /* webpackMode: "loadable" */ './features/dataSources/dataSourcesPage'
    ),
  {
    fallback: <LoadableLoader />
  }
)
const Annotations = loadable(() => import('./features/annotator/annotations'), {
  fallback: <LoadableLoader />
})
const EntityDetails = loadable(() => import('./features/entityDetails/entityDetails'), {
  fallback: <LoadableLoader />
})
const Insights = loadable(() => import('./features/insights'), {
  fallback: <LoadableLoader />
})
const PrivacyPartners = loadable(() => import('./features/privacyPartners'), {
  fallback: <LoadableLoader />
})
const EntityListPage = loadable(() => import('./features/entities/entititesListPage'), {
  fallback: <LoadableLoader />
})
const SettingsDashboard = loadable(() => import('./features/configurationSettings/settings'), {
  fallback: <LoadableLoader />
})
const DataSourceFormUnstructured = loadable(
  () => import('./features/dataSources/components/UnstructuredForm'),
  {
    fallback: <LoadableLoader />
  }
)
const DataSourceTypeForm = loadable(
  () => import('./features/dataSources/components/DataSourceTypeForm/dataSourceTypeForm'),
  {
    fallback: <LoadableLoader />
  }
)
const OnDemandScanning = loadable(
  () => import('./features/onDemandScanningFiles/pageOnDemandScanning'),
  {
    fallback: <LoadableLoader />
  }
)
const ObjectsListPage = loadable(
  () => import('./features/classifications/documentsListByDatasource'),
  {
    fallback: <LoadableLoader />
  }
)
const DocumentsListPage = loadable(() => import('./features/classifications/documentsListPage'), {
  fallback: <LoadableLoader />
})
const DashboardMasterContainer = loadable(
  () => import('./features/dashboards/dashboardMasterContainer'),
  {
    fallback: <LoadableLoader />
  }
)
const DataSourceMixedSettings = loadable(
  () => import('./features/dataSourcesMixed/settings/settings'),
  {
    fallback: <LoadableLoader />
  }
)
const DataSourceMixedDashboard = loadable(
  () => import('./features/dataSourcesMixed/dashboard/dashboard'),
  {
    fallback: <LoadableLoader />
  }
)
const PoliciesDashboardContainer = loadable(
  () => import('./features/policies/PoliciesDashboardContainer'),
  {
    fallback: <LoadableLoader />
  }
)
const NotificationsComp = loadable(
  () => import('./features/notifications/StandAloneNotifications'),
  {
    fallback: <LoadableLoader />
  }
)
const FilterCreateEdit = loadable(() => import('./features/policies/FilterCreateEdit'), {
  fallback: <LoadableLoader />
})
const DsrDashboard = loadable(() => import('./features/dsr/dsr'), {
  fallback: <LoadableLoader />
})
const RopaDashboard = loadable(() => import('./features/ropa/ropa'), {
  fallback: <LoadableLoader />
})
const PiaDashboard = loadable(() => import('./features/pia/pia'), {
  fallback: <LoadableLoader />
})
const CookieConsent = loadable(() => import('./features/cookieConsent/cookieConsentRouter'), {
  fallback: <LoadableLoader />
})
const ConsentManagement = loadable(
  () => import('./features/consentManagement/consentManagementRouter'),
  {
    fallback: <LoadableLoader />
  }
)
const PrintRopaReportPage = loadable(() => import('./print/print-ropa'), {
  fallback: <LoadableLoader />
})
const PrintPiaReportPage = loadable(() => import('./print/print-pia'), {
  fallback: <LoadableLoader />
})
const PrintDsrReportPage = loadable(() => import('./print/print-dsr'), {
  fallback: <LoadableLoader />
})
const PrintCCVersionPage = loadable(() => import('./print/print-cc-version'), {
  fallback: <LoadableLoader />
})
const ManageAccountContainer = loadable(
  () => import('./features/manageAccount/manageAccountContainer'),
  {
    fallback: <LoadableLoader />
  }
)
const AccessControl = loadable(() => import('./features/accessControl'), {
  fallback: <LoadableLoader />
})

const CloudPlatforms = loadable(() => import('./features/cloudPlatforms'), {
  fallback: <LoadableLoader />
})

const CloudPlatformSettings = loadable(
  () => import('./features/cloudPlatforms/components/cloudPlatformsSettings'),
  {
    fallback: <LoadableLoader />
  }
)

const UnregisteredCloudDatasources = loadable(
  () => import('./features/cloudPlatforms/components/unregisteredCloudDatasources'),
  {
    fallback: <LoadableLoader />
  }
)
const PrivacyOpsDashboard = loadable(
  () => import('./features/privacyOpsOverview/privacyOpsOverviewPage'),
  {
    fallback: <LoadableLoader />
  }
)

const App = (): React.ReactElement | null => {
  const language = useSelector((state: RootState) => state.lang.language)
  const showLoader = useSelector(
    () => getShowLoader(ACTION_USER_INFO) || getShowLoader(ACTION_FETCH_FEATURE_FLAGS)
  )
  const persistedLanguage = language || DEFAULT_LANGUAGE

  const excludeUrls = NON_PROTECTED_ROUTES.map((url) => url.replace('/', '')) // remove leading slash for pattern
    .join('|')

  const redirectRegex = new RegExp(`^(?!\\/(${excludeUrls})$).*`)

  return (
    <ThemeContextProvider>
      <SnackbarProvider>
        <Router history={history}>
          <IntlProvider locale={persistedLanguage} messages={MESSAGES[persistedLanguage]}>
            <Switch>
              <NonProtectedRoute path={URL_PRINT_CLOSING} exact component={PrintClosingPage} />
              <NonProtectedRoute
                path={URL_PRINT_COVER}
                exact
                component={PrintCover}
                date={new Date().toLocaleString('en-US')}
              />
            </Switch>
            <AuthProvider>
              <PermissionProvider>
                <LoaderView showLoader={showLoader} />

                <Switch>
                  <ProtectedRoute
                    path={URL_UNAUTHORIZED}
                    requireAuth={true}
                    component={AccessDenied}
                  />

                  <ProtectedRoute
                    path={[`${URL_DASHBOARD}/old`]}
                    exact
                    component={MainDashBoard}
                    action={ACTIONS.DASHBOARD_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_DASHBOARD}/:subPage`,
                      `${URL_DASHBOARD}/:subPage/:dashboardId`,
                      `${URL_DASHBOARD}/:subPage/:dashboardId/:dataSourceId`,
                      `${URL_DASHBOARD}`
                    ]}
                    exact
                    component={MainDashBoardV2}
                    action={ACTIONS.DASHBOARD_VIEW}
                  />

                  <ProtectedRoute path={URL_SEARCH} component={GlobalSearch} />
                  <ProtectedRoute path={URL_DAYZERO} component={FirstLanding} />
                  <ProtectedRoute
                    path={[
                      `${URL_ENTITIES}/:entityId/:subPage`,
                      `${URL_ENTITIES}/:entityId`,
                      `${URL_VIOLATIONS}/:entityId`,
                      `${URL_USERS}/:entityId`
                    ]}
                    component={EntityDetails}
                    action={ACTIONS.ENTITIES_VIEW}
                  />
                  <Redirect from={URL_ATTRIBUTES_SET} to={URL_INSIGHTS + URL_ATTRIBUTES_SET} />
                  <ProtectedRoute
                    path={[
                      `${URL_DSR}/:subPage/:itemId/:stepId/:tabId`,
                      `${URL_DSR}/:subPage/:itemId/:stepId`,
                      `${URL_DSR}/:subPage/:itemId`,
                      `${URL_DSR}/:subPage`
                    ]}
                    component={DsrDashboard}
                    action={ACTIONS.DSR_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_COOKIES_CONSENT}/:subPage/:itemId/:stepId/:tabId`,
                      `${URL_COOKIES_CONSENT}/:subPage/:itemId/:stepId`,
                      `${URL_COOKIES_CONSENT}/:subPage/:itemId`,
                      `${URL_COOKIES_CONSENT}/:subPage`
                    ]}
                    component={CookieConsent}
                    action={ACTIONS.COOKIE_CONSENT_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_CONSENT_MANAGEMENT}/:subPage/:itemId/:stepId/:tabId`,
                      `${URL_CONSENT_MANAGEMENT}/:subPage/:itemId/:stepId`,
                      `${URL_CONSENT_MANAGEMENT}/:subPage/:itemId`,
                      `${URL_CONSENT_MANAGEMENT}/:subPage`,
                      `${URL_CONSENT_MANAGEMENT}`
                    ]}
                    component={ConsentManagement}
                    action={ACTIONS.CONSENT_MANAGEMENT_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_INSIGHTS}/:subPage/:subPageId?/:activeTab?/:activeSubTab?/:activeSubSubTab?`
                    ]}
                    component={Insights}
                    action={ACTIONS.INSIGHTS_VIEW}
                  />
                  <ProtectedRoute
                    path={[`${URL_PRIVACY_PARTNERS}/:subPageId?/:activeTab?`]}
                    component={PrivacyPartners}
                    action={ACTIONS.PRIVACY_PARTNERS}
                  />
                  <ProtectedRoute
                    path={[URL_ENTITIES, URL_ENTITIES_DELETED, URL_VIOLATIONS, URL_USERS]}
                    component={EntityListPage}
                    action={ACTIONS.ENTITIES_VIEW}
                  />
                  <ProtectedRoute
                    path={[URL_DATA_SOURCES, URL_DATA_SOURCES_STRUCTURED]}
                    exact
                    component={DataSourcesPage}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_DATA_SOURCES}/:dataSourceId/:subPage/:subPageId?/:activeTab?`,
                      `${URL_DATA_SOURCES}/:dataSourceId/:subPage/:subPageId?/:activeTab?/:tabId?`,
                      `${URL_DATA_SOURCES}/:dataSourceId`
                    ]}
                    exact
                    component={DashboardMasterContainer}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      URL_DATA_SOURCES_STRUCTURED +
                        '/:dataSourceId/:subPage/:subPageId?/:activeTab?/:tabId?',
                      URL_DATA_SOURCES_STRUCTURED + '/:dataSourceId/:subPage',
                      URL_DATA_SOURCES_STRUCTURED + '/:dataSourceId',
                      URL_DATABASES + '/:databaseId/:subPage/:clusterId',
                      URL_DATABASES + '/:databaseId/:subPage',
                      URL_DATABASES + '/:databaseId',
                      URL_TABLES + '/:tableId/:subPage',
                      URL_TABLES + '/:tableId',
                      URL_VIEWS + '/:viewId/:subPage',
                      URL_VIEWS + '/:viewId'
                    ]}
                    component={DataSourceMixedDashboard}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={URL_DATASOURCE_FORM_STRUCTURED}
                    component={DataSourceMixedSettings}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={URL_DATASOURCE_FORM_UNSTRUCTURED}
                    component={DataSourceFormUnstructured}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={URL_ONDEMAND}
                    component={OnDemandScanning}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={URL_DATASOURCE_FORM}
                    component={DataSourceTypeForm}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={URL_REGISTER_ELASTIC_SEARCH}
                    component={ElasticSearchForm}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_POLICIES}${URL_WORKFLOWS}`,
                      `${URL_POLICIES}${URL_CREATE_WORKFLOW}`
                    ]}
                    exact
                    component={PoliciesDashboardContainer}
                    action={ACTIONS.WORKFLOWS_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      URL_POLICIES,
                      `${URL_RULE_SET}/:subPage`,
                      `${URL_POLICIES}/:subPage`,
                      `${URL_POLICIES}/:subPage/:id`,
                      `${URL_POLICIES}/:subPage/:id/:alertSubPage`,
                      `${URL_POLICIES}/:subPage/:id/:alertSubPage/:alertSubPageId`
                    ]}
                    exact
                    component={PoliciesDashboardContainer}
                    action={ACTIONS.RULE_SETS_VIEW}
                  />
                  <ProtectedRoute
                    path={[`${URL_NOTIFICATIONS}`]}
                    exact
                    component={NotificationsComp}
                    action={ACTIONS.NOTIFICATIONS_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      URL_MANAGE_ACCOUNT
                      // `${URL_LANGUAGE}/:subPage`,
                    ]}
                    exact
                    component={ManageAccountContainer}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_SETTINGS}/:subPage/:subPageId?`,
                      `${URL_SETTINGS}/:subPage/:subPageId?/:action`
                    ]}
                    exact
                    component={SettingsDashboard}
                    action={ACTIONS.SETTINGS_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      URL_INSIGHTS + URL_DOCUMENTS_CLASSIFIED,
                      URL_INSIGHTS + URL_DOCUMENTS_UNCLASSIFIED_WITH_ENTITIES
                    ]}
                    exact
                    component={DocumentsListPage}
                    action={ACTIONS.CLASSIFICATIONS_VIEW}
                  />
                  <ProtectedRoute
                    path={URL_DOCUMENTS_ALL}
                    exact
                    component={ObjectsListPage}
                    action={ACTIONS.INSIGHTS_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_DOCUMENT}`,
                      `${URL_DOCUMENTS_ALL}/:documentId`,
                      `${URL_DOCUMENTS_CLASSIFIED}/:documentId`,
                      `${URL_DOCUMENTS_UNCLASSIFIED_WITH_ENTITIES}/:documentId`,
                      `${URL_DOCUMENTS_UNCLASSIFIED_WITHOUT_ENTITIES}/:documentId`,
                      `${URL_CONVERSATIONS}/:documentId`,
                      `${URL_ATTRIBUTES}/:documentId`,
                      `${URL_EMAILS}/:documentId`,
                      `${URL_TICKETS}/:documentId`
                    ]}
                    exact
                    hideNavBar
                    component={Annotations}
                    action={ACTIONS.FILES_VIEW}
                  />
                  <ProtectedRoute
                    path="/lightbeam-design-system"
                    exact
                    component={LightBeamDesignSystem}
                  />
                  <ProtectedRoute path={URL_FILTERS} exact component={SelectFileToCreateFilter} />
                  <ProtectedRoute
                    path={[URL_FILTER, `${URL_FILTER}/:filterId`]}
                    exact
                    component={FilterCreateEdit}
                  />
                  <ProtectedRoute
                    path={[`${URL_PRIVACY_OPS + URL_OVERVIEW}`]}
                    component={PrivacyOpsDashboard}
                    action={ACTIONS.PRIVACY_OPS_DASHBOARD}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_ROPA}/:subPage/:stepId/:subSubPage/:tabId`,
                      `${URL_ROPA}/:subPage/:stepId/:subSubPage`,
                      `${URL_ROPA}/:subPage/:stepId`,
                      `${URL_ROPA}/:subPage`,
                      URL_ROPA
                    ]}
                    component={RopaDashboard}
                    action={ACTIONS.ROPA_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_PIA}/:subPage/:stepId/:subSubPage/:tabId`,
                      `${URL_PIA}/:subPage/:stepId/:subSubPage`,
                      `${URL_PIA}/:subPage/:stepId`,
                      `${URL_PIA}/:subPage`,
                      URL_PIA
                    ]}
                    component={PiaDashboard}
                    action={ACTIONS.PIA_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_ACCESS_CONTROL}/:subPage/:subSubPage/:tabId`,
                      `${URL_ACCESS_CONTROL}/:subPage/:subSubPage`,
                      `${URL_ACCESS_CONTROL}/:subPage`,
                      URL_ACCESS_CONTROL
                    ]}
                    component={AccessControl}
                    action={ACTIONS.GOVERNANCE_VIEW}
                  />
                  <ProtectedRoute
                    path={[`${URL_CLOUD_PLATFORMS}/:cloudPlatformId`, URL_CLOUD_PLATFORMS]}
                    component={CloudPlatforms}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={[
                      `${URL_CLOUD_PLATFORMS_ONBOARDING}/:cloudPlatform`,
                      URL_CLOUD_PLATFORMS_ONBOARDING
                    ]}
                    component={CloudPlatformSettings}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={[`${URL_CLOUD_RESOURCES}/:cloudResourceId`, URL_CLOUD_RESOURCES]}
                    component={UnregisteredCloudDatasources}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    exact
                    path={URL_VIVA_ENGAGE_CALLBACK}
                    component={MsVivaEngageCallback}
                    action={ACTIONS.DATA_SOURCE_VIEW}
                  />
                  <ProtectedRoute
                    path={URL_PRINT_ROPA_CONTENT}
                    exact
                    component={ReportingErrorBoundary}
                    requireAuth={false}
                  >
                    <PrintRopaReportPage />
                  </ProtectedRoute>
                  <ProtectedRoute
                    path={URL_PRINT_PIA_CONTENT}
                    exact
                    component={ReportingErrorBoundary}
                    requireAuth={false}
                  >
                    <PrintPiaReportPage />
                  </ProtectedRoute>
                  <ProtectedRoute
                    path={URL_PRINT_DSR_CONTENT}
                    exact
                    component={ReportingErrorBoundary}
                    requireAuth={false}
                  >
                    <PrintDsrReportPage />
                  </ProtectedRoute>
                  <ProtectedRoute
                    path={URL_DELTA_PRINT}
                    exact
                    component={DeltaPrintPage}
                    requireAuth={false}
                  />
                  <ProtectedRoute
                    path={URL_PRINT_CC_VERSION_CONTENT}
                    exact
                    component={PrintCCVersionPage}
                    requireAuth={false}
                  />
                  <ProtectedRoute
                    path={URL_PRINT}
                    exact
                    component={ReportingErrorBoundary}
                    requireAuth={false}
                  >
                    <PrintPage />
                  </ProtectedRoute>
                  <ProtectedRoute path={'/'} exact component={Loading} requireAuth={false} />
                  <Redirect from={redirectRegex} to={URL_DASHBOARD} />
                </Switch>
                <Notification />
                <Modals />
              </PermissionProvider>
            </AuthProvider>
          </IntlProvider>
        </Router>
      </SnackbarProvider>
    </ThemeContextProvider>
  )
}

export default withErrorBoundary(App)
